<template>
  <div class="star-task-container">
    <div class="form-card">
      <h2 class="form-title">星图任务配置</h2>
      <a-form :model="formState" name="starTaskForm" class="star-task-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <div class="form-section">
          <div class="section-title">认证信息</div>
          <a-form-item label="Cookie" name="cookie">
            <a-textarea v-model:value="formState.cookie" placeholder="请输入Cookie" :auto-size="{ minRows: 3, maxRows: 6 }" class="custom-textarea" />
          </a-form-item>
          <a-form-item label="X-CSRF-Token" name="xCsrfToken">
            <a-input v-model:value="formState.xCsrfToken" placeholder="请输入X-CSRF-Token" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>
          <a-form-item label="X-SecSDK-CSRF-Token" name="xSecsdk">
            <a-input v-model:value="formState.xSecsdk" placeholder="请输入X-SecSDK-CSRF-Token" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>
          <a-form-item label="批次(首次拉取必须为空)" name="batchNumber">
            <a-input v-model:value="formState.batchNumber" placeholder="请输入批次,格式为2025-01-24 11:56:02" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>
        </div>

        <div class="form-section">
          <div class="section-title">接收配置</div>
          <a-form-item label="接收群组" name="chatGroupName">
            <a-input readonly v-model:value="formState.chatGroupName" placeholder="请输入接收群组" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>
          <a-form-item label="接收群组ID" name="chatGroupId">
            <a-input readonly v-model:value="formState.chatGroupId" placeholder="请输入接收群组ID" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>

          <a-form-item label="接收人" name="userName">
            <a-input readonly v-model:value="formState.userName" placeholder="请输入接收人" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>

          <a-form-item label="接收人ID" name="userId">
            <a-input readonly v-model:value="formState.userId" placeholder="请输入接收人" :auto-size="{ minRows: 1, maxRows: 1 }" class="custom-textarea" />
          </a-form-item>
        </div>
      </a-form>
      <div class="button-group">
        <a-button type="primary" @click="showSaveConfirmModal" :loading="saveLoading" class="custom-button">保存配置</a-button>
        <a-button type="primary" @click="showConfirmModal" :loading="executeLoading" class="custom-button execute-button">执行任务</a-button>
      </div>
    </div>
    <a-modal
      v-model:visible="saveConfirmModalVisible"
      title="确认保存"
      @ok="handleSaveCookie"
      @cancel="saveConfirmModalVisible = false"
      okText="确认"
      cancelText="取消"
    >
      <p>确定要保存当前配置吗？</p>
    </a-modal>
    <a-modal
      v-model:visible="confirmModalVisible"
      title="确认执行"
      @ok="handleExecute"
      @cancel="confirmModalVisible = false"
      okText="确认"
      cancelText="取消"
    >
      <p>确定要执行星图任务吗？</p>
    </a-modal>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import axios from '@/utils/axios';
// import axios from 'axios';

export default {
  name: 'StarTask',
  data() {
    return {
      formState: {
        cookie: 'HMACCOUNT=CD897B1FB24D9E16; csrf_session_id=55aec4913ab5b17af2d0d989d8635f31; tt_webid=7441837819700610587; passport_csrf_token=0db91be2cbd9efea29c4e9203bfb2336; passport_csrf_token_default=0db91be2cbd9efea29c4e9203bfb2336; csrftoken=YUBTTJzKXmq9p8p01gpzHDdZR5nsqhFi; auth_token=81667e588eb04dfcade3508907ccb546; auth_token_ss=81667e588eb04dfcade3508907ccb546; Hm_lvt_5d77c979053345c4bd8db63329f818ec=1735639858; is_staff_user=false; Hm_lpvt_5d77c979053345c4bd8db63329f818ec=1737620018; s_v_web_id=verify_m6923l32_875c8f7b_c963_4767_891f_49e523568747; tt_scid=0zFIGPiuGjdvaVgkBSb4pvA8lwEqtas6KUrLxznEkj6R5tsq35ujElzNk.FuIANU8cc8; passport_auth_status=c7f4b43a0ccbcfdcf55a2ce8048235a3%2Cb3e226601f6ead7c9501fdfdf101c70b; passport_auth_status_ss=c7f4b43a0ccbcfdcf55a2ce8048235a3%2Cb3e226601f6ead7c9501fdfdf101c70b; sid_guard=8ddf8b80f2d87e56289870dd362508e1%7C1737620031%7C5184002%7CMon%2C+24-Mar-2025+08%3A13%3A53+GMT; uid_tt=6e92d5ab50bc645a95d28853f8a288c1; uid_tt_ss=6e92d5ab50bc645a95d28853f8a288c1; sid_tt=8ddf8b80f2d87e56289870dd362508e1; sessionid=8ddf8b80f2d87e56289870dd362508e1; sessionid_ss=8ddf8b80f2d87e56289870dd362508e1; sid_ucp_v1=1.0.0-KDhiNjcyYWEwMDVkNDhmNWVmOWIwYjI4OGIzZTk1MmVjODllZGNkNTAKFQijrKa4nQMQv_THvAYYpgw4AUDrBxoCbGYiIDhkZGY4YjgwZjJkODdlNTYyODk4NzBkZDM2MjUwOGUx; ssid_ucp_v1=1.0.0-KDhiNjcyYWEwMDVkNDhmNWVmOWIwYjI4OGIzZTk1MmVjODllZGNkNTAKFQijrKa4nQMQv_THvAYYpgw4AUDrBxoCbGYiIDhkZGY4YjgwZjJkODdlNTYyODk4NzBkZDM2MjUwOGUx; star_sessionid=8ddf8b80f2d87e56289870dd362508e1; possess_scene_star_id=1787241089022116',
        xCsrfToken: 'YUBTTJzKXmq9p8p01gpzHDdZR5nsqhFi',
        xSecsdk: '0001000000018bc9455c3f9886e093e32c8c6e96cdd9ad38279bdaa93bfaba9a3b29e3bcf01f181d83cd02d969bf',
        batchNumber:'',
        /*batchNumber: new Date().toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-'), //当前时间 yyyy-mm-dd hh:mm:ss*/
        chatGroupName: '巨量星图数据-艾嘉',
        chatGroupId: 'oc_e09ba1827ce6df8f204760c48ab7a84c',
        userName: '恩泰',
        userId: '9fb85ffb'
      },
      confirmModalVisible: false,
      saveConfirmModalVisible: false,
      executeLoading: false,
      saveLoading: false
    }
  },
  methods: {
    showSaveConfirmModal() {
      this.saveConfirmModalVisible = true;
    },
    async handleSaveCookie() {
      this.saveConfirmModalVisible = false;
      this.saveLoading = true;
      try {
        // TODO: 实现保存cookie的逻辑
        //模拟接口调用延迟2s返回数据
        await new Promise(resolve => setTimeout(resolve, 2000));
        console.log('保存cookie', this.formState);
        message.success('配置保存成功');
      } catch (error) {
        console.error('保存配置出错:', error);
        message.error('保存配置失败');
      } finally {
        this.saveLoading = false;
      }
    },
    showConfirmModal() {
      this.confirmModalVisible = true;
    },
    async handleExecute() {
      this.confirmModalVisible = false;
      this.executeLoading = true;
      try {
        const response =  axios.post('/xt_task/', this.formState);
        message.success('任务已经提交！');
      } catch (error) {
        console.error('执行任务出错:', error);
        message.error('执行任务失败，请检查网络连接');
      } finally {
        this.executeLoading = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.star-task-container {
  padding: 12px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .form-card {
    width: 100%;
    max-width: 800px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    padding: 16px;
    margin: 0 auto;
    overflow-y: auto;
    max-height: calc(100vh - 48px);

    .form-title {
      font-size: 18px;
      font-weight: 500;
      color: #1f1f1f;
      margin-bottom: 16px;
      text-align: center;
    }

    .form-section {
      margin-bottom: 16px;
      padding: 12px;
      background: #fafafa;
      border-radius: 6px;

      .section-title {
        font-size: 15px;
        font-weight: 500;
        color: #333;
        margin-bottom: 12px;
        padding-left: 10px;
        border-left: 3px solid #1890ff;
      }
    }

    .star-task-form {
      :deep(.ant-form-item) {
        margin-bottom: 12px;
      }

      :deep(.ant-form-item-label > label) {
        color: #666;
        font-weight: 500;
      }

      .custom-textarea {
        border-radius: 4px;
        border-color: #d9d9d9;
        transition: all 0.3s;
        resize: vertical;
        min-height: 28px;

        &:hover, &:focus {
          border-color: #40a9ff;
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
        }
      }
    }

    .button-group {
      position: sticky;
      bottom: 0;
      background: #fff;
      margin-top: 16px;
      text-align: center;
      padding: 16px 0;
      border-top: 1px solid #f0f0f0;

      .custom-button {
        height: 32px;
        padding: 0 20px;
        font-size: 14px;
        border-radius: 4px;
        margin: 0 8px;

        &.execute-button {
          background: #52c41a;
          border-color: #52c41a;

          &:hover {
            background: #73d13d;
            border-color: #73d13d;
          }
        }
      }
    }
  }
}
</style>